import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  OnChanges,
} from "@angular/core";
import Question from "@shared/types/question.type";
import { remove } from "lodash";
/**
 * TODO:
 * This will need to be a wrapper around specific question types
 * Should probably implement ControlValueAccessor for use as a form control
 * https://coryrylan.com/blog/angular-custom-form-controls-with-reactive-forms-and-ngmodel
 */
@Component({
  selector: "app-question",
  templateUrl: "./question.component.html",
  styleUrls: ["./question.component.scss"],
})
export class QuestionComponent implements OnChanges {
  private selectedChoices: string[] = [];
  private questionData;
  public displayChoices = [];

  private alpha = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  private tf = "TF";

  @ViewChild("choiceForm")
  choiceForm: any;

  @Input()
  /**
   * TODO:
   * We probably shouldn't be resetting form in a question setter
   * however constructor isn't being called when question changes
   */
  set question(question: Question) {
    this.questionData = question;
    this.selectedChoices = [];
    // this.choiceForm.nativeElement.reset();
  }

  get question(): Question {
    return this.questionData;
  }

  @Output() choiceEvent = new EventEmitter<string[]>();

  constructor() {}

  ngOnChanges() {
    if (this.questionData) {
      this.displayChoices = this.questionData.choices.map((choice, i) => {
        return {
          index:
            this.question.type === "mc" || this.question.type === "mc_multi"
              ? this.alpha[i]
              : this.tf[i],
          answerText: choice.text,
          selected: false,
          status: choice.status,
          hidden: choice.hidden,
        };
      });
    }
  }

  allowMultiSelections() {
    return this.question.mcAnswer && this.question.mcAnswer.choices.length > 1;
  }

  isSelected(i: string) {
    return this.selectedChoices.indexOf(i) > -1;
  }

  setChoice(choice: string) {
    this.allowMultiSelections()
      ? this.setMultiAnswer(choice)
      : this.setSingleAnswer(choice);
    this.sendAnswer();
  }

  onEsAnswerItemSelected(evt) {
    this.setChoice(evt.detail.index);
  }

  maxSelections() {
    let choices = this.question.mcAnswer.choices;
    return this.question.enableAllThatApply
      ? false
      : this.selectedChoices.length === choices.length;
  }

  setMultiAnswer(choice) {
    if (this.isSelected(choice)) {
      remove(
        this.selectedChoices,
        (selectedChoice) => selectedChoice == choice
      );
    } else if (!this.maxSelections()) {
      this.selectedChoices.push(choice + "");
    }

    this.setSelected();
  }

  setSelected() {
    this.displayChoices = this.displayChoices.map((c) => {
      return {
        ...c,
        selected: this.isSelected(c.index),
      };
    });
  }

  setSingleAnswer(choice) {
    this.selectedChoices = [choice + ""];
    this.setSelected();
  }

  sendAnswer() {
    this.choiceEvent.emit(
      this.selectedChoices.map((c) => {
        return this.question.type === "mc" || this.question.type === "mc_multi"
          ? this.alpha.indexOf(c) + ""
          : this.tf.indexOf(c) + "";
      })
    );
  }
}
